module.exports = __webpack_public_path__ + "static/qh_2.a8fa861b.jpg";